<template>
  <div class="fourth" style="background-image: linear-gradient(#fff, #fbfbfd);position: relative" :style="{height:screenHeight}">
    <span class="title text-center" :class="activeShow===4?'animate__animated animate__bounceInUp':''">全行业定制化配送</span>
    <span class="subtitle text-center" :class="activeShow===4?'animate__animated animate__bounceInUp':''">无需预约 随叫随到 超过150万的商家选择使用365跑腿</span>
    <div style="width:94%;margin-left:2.3%;float:left;border-radius:10px;box-shadow: 2px 1px 10px #ddd;" :style="{maxWidth: screenWidth}">
    <van-tabs v-model="activeIndex" color="#fe7028" ref="fourthTabs" :before-change="tabsChange" :swipeable="true" :ellipsis="false">
      <van-tab v-for="(items,index) in fourthCardList" :key="index">
        <template #title>{{items.navName}}</template>
        <img :src="items.img" style="width:100%;float:left;margin-top:10px;">
        <ul class="descList">
          <li v-for="(descList,dindex) in items.descList" :key="dindex"> <i class="orangeDot"></i><span>{{descList}}</span></li>
        </ul>
      </van-tab>
    </van-tabs>
    </div>
    <div class="indicat">
      <ul>
        <li v-for="(item,index) in fourthCardList" :key="index" :class="index===activeIndex?'active':''" @click="onTabsChange(index)"></li>
      </ul>
    </div>
    <div class="width100 text-center">
      <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/down-arrow-grey.png" class="downButton" @click="moveSectionDown">
    </div>
  </div>
</template>

<script>
export default {
  name: 'fourthPage',
  data(){
    return {
      screenHeight:0,
      screenWidth:0,
      activeIndex:0,
      fourthCardList:[
        {
          navName:"外卖餐饮配送",
          img:"https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/fourthCard1.png",
          descList:[
            '全程覆盖，无距离限制',
            '一对一服务，专业高效',
            '订餐高峰期，运力快速调配',
            '支持取餐免打扰模式'
          ]
        },
        {
          navName:"鲜花配送",
          img:"https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/fourthCard2.png",
          descList:[
            '全程覆盖，无距离限制',
            '一对一服务，专业高效',
            '订餐高峰期，运力快速调配',
            '支持取餐免打扰模式'
          ]
        },
        {
          navName:"3C数码配送",
          img:"https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/fourthCard3.png",
          descList:[
            '全程覆盖，无距离限制',
            '一对一服务，专业高效',
            '订餐高峰期，运力快速调配',
            '支持取餐免打扰模式'
          ]
        },
        {
          navName:"蛋糕配送",
          img:"https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/fourthCard4.png",
          descList:[
            '全程覆盖，无距离限制',
            '一对一服务，专业高效',
            '订餐高峰期，运力快速调配',
            '支持取餐免打扰模式'
          ]
        }
      ],
    }
  },
  props: {
    activeShow: Number
  },
  mounted(){
    // 定时器 五秒换一页
    var that = this;
    setInterval(function () {
      that.onTabsChange(that.activeIndex+1);
    }, 5000);
  },
  created(){
    this.screenHeight = document.documentElement.clientHeight+'px';
    this.screenWidth = document.documentElement.clientWidth+'px';
  },
  methods:{
    // 翻页方法 子传父
    moveSectionDown(){
      this.$emit('moveSectionDown');
    },
    // 指示器切换回调
    onTabsChange(index) {
      this.activeIndex = index;
      this.$refs.fourthTabs.scrollTo(index);
    },
    // 切换tab页
    tabsChange(index){
      this.activeIndex = index;
    },
  }
}
</script>
<style>
  /*iphone5样式适配*/
  @media (max-height: 569px){
    .orangeButton{margin-top:10px !important;padding:5px 0 !important;}
    .fourth .indicat{margin-top:10px !important;}
    .indicat ul li{width:10px !important;height:10px !important;}
    .fourth .van-swipe{padding-bottom:10px !important;}
    .fourth .title{margin-top:15% !important;}
  }
  /*iphoneX样式适配*/
  @media (min-height: 737px) and (max-height: 820px){
    .subtitle{margin-bottom: 30px !important;}
    .orangeButton{margin-top:15% !important;margin-bottom:10%;}
    .fourth .van-swipe{padding-bottom:30px !important;}
  }
</style>
